import permission, {hasPermission} from './permission'
import Vue from 'vue'

Vue.directive('permission', permission);

export default hasPermission
